import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const BlogRootEntityTypes = [
  EntityTypeEnum.BlogPageBody,
  EntityTypeEnum.BlogPostLayoutBody,
  EntityTypeEnum.BlogPostBody,
  EntityTypeEnum.WebsiteBlogPageBody,
  EntityTypeEnum.WebsiteBlogPostLayoutBody,
  EntityTypeEnum.WebsiteBlogPostBody,
]
